import axios, { addInterceptors } from './interceptor-axios';
import config from '~/config';

class TextService {
  constructor(token) {
    const headers = {};
    if (token) {
      headers.Authorization = token;
    }
    this.axios = axios.create({
      baseURL: config.apiDataURL,
      headers,
    });
    addInterceptors(this.axios);
  }

  listTexts = ({ categoryID, page }) => {
    const request = {
      method: 'GET',
      url: '/texts',
      params: {
        category_id: categoryID,
        page,
        max_results: 30,
      },
    };
    return this.axios(request);
  };

  insertDbOfText = ({
    title,
    description,
    dataURL,
    thumbnailURL,
    width,
    height,
    fontIDs,
    creatorRole,
    category_id,
  }) => {
    const request = {
      method: 'POST',
      url: '/texts',
      data: {
        title,
        description,
        data_url: dataURL,
        thumbnail_url: thumbnailURL,
        width,
        height,
        fontIDs,
        creatorRole,
        category_id,
      },
    };
    return this.axios(request);
  };

  getUrlOfItem = (id) => {
    const request = {
      method: 'POST',
      url: '/texts/download',
      data: {
        id,
      },
    };
    return this.axios(request);
  };

  updateText = ({
    id,
    title,
    description,
    dataURL,
    thumbnailURL,
    width,
    height,
    fontIDs,
    category_id,
  }) => {
    const request = {
      method: 'PUT',
      url: '/texts',
      data: {
        id,
        title,
        description,
        data_url: dataURL,
        thumbnail_url: thumbnailURL,
        width,
        height,
        fontIDs,
        category_id,
      },
    };
    return this.axios(request);
  };

  deleteText = (id) => {
    const request = {
      method: 'DELETE',
      url: '/texts',
      data: {
        id,
      },
    };
    return this.axios(request);
  };

  listTextsByCategory = ({ categoryID, page }) => {
    const request = {
      method: 'GET',
      url: '/texts-by-category',
      params: {
        category_id: categoryID,
        page,
        max_results: 30,
      },
    };
    return this.axios(request);
  };

  searchTexts = ({ categoriesId, page, lang, keyword }) => {
    const request = {
      method: 'GET',
      baseURL: config.apiSearchURL,
      url: '/texts',
      params: {
        categoriesId,
        page,
        max_results: 30,
        lang,
        keyword,
      },
    };
    return this.axios(request);
  };
}

export default new TextService();
